export const UPLOAD_FILE_TYPE = {
  WEBSITE_ATTACHMENT: "WEBSITE_ATTACHMENT",
  MODEL_PHOTO: "MODEL_PHOTO",
}
